import { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";

export default function SignaturePad({ setSignature, classes }) {
  const sigCanvas = useRef();
  const [warning, setWarning] = useState();

  const createSignature = () => {
    try {
      if (sigCanvas.current.isEmpty())
        throw new Error("Please sign in the gray box above.");
      const URL = sigCanvas.current.toDataURL("base64");
      setSignature(URL);
    } catch (err) {
      setWarning(err.message);
      console.error(err.message);
    }
  };

  return (
    <div className="grid gap-4 text-sm">
      <SignatureCanvas
        penColor="black"
        canvasProps={{
          width: "full",
          height: "full",
          className:
            "border-2 border-yellow-600 mx-auto rounded-xl dark:bg-stone-600 bg-gray-200",
        }}
        ref={sigCanvas}
      />
      {warning && <p className="mx-auto warning">{warning}</p>}
      <div className={classes || "grid gap-4 lg:grid-cols-2 lg:w-1/2 lg:mx-auto"}>
        <div
          className="btn-secondary"
          onClick={() => sigCanvas.current.clear()}
        >
          Clear
        </div>
        <div className="btn-primary" onClick={createSignature}>
          Confirm
        </div>
      </div>
    </div>
  );
}
